<template>
<div>

	<Transition name="slide-up">
      <button v-if="theMode === 'check'"
             >
              <img src="../assets/status/ok.svg" alt="what">
 
              </button>
      <button v-else-if="theMode === 'cross'"
             >

              <img src="../assets/status/cancel.svg" alt="what">

               
              
              </button>
               <button v-else-if="theMode === 'or'"
             >
              <img src="../assets/status/or.svg" alt="what">
              
              </button>
      
    </Transition>


</div>


</template>


<script>
export default {

    props: {
     theMode:String 
    }, 
    data(){
        return {
            mode: this.theMode
        }
    }
}
</script>

<style scoped>



button{
    position: absolute;
  border:none; 
  background:none; 
  z-index: 400;

    /* filter: drop-shadow(10px 10px 10px #00000076); */
}


img{
    position: relative;
    z-index: 5000;
}
#test123{
    background-color: red;
    width:50vw;
    height: 50vh;
    position: absolute;
    z-index: 350;
}

div{
    position: absolute; 
    /* top:50%;  */
    left:50%; 
    
    display: flex;
    align-items: center;
    justify-content: center;

    height: min(550px, 75vmin); 
    margin-block: 2em;
}


@media (max-aspect-ratio: 5/6) {
    img{
        transform: scale(60%);
    }
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.55s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.slide-up-enter-from {
  opacity: 0;
  transform: scale(20%); 
}

.slide-up-leave-to {
  opacity: 0;
  transform: scale(0%); 
}


</style>